export default "__VITE_ASSET__BAMSPdDK__";